import { useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";
import { DashboardType, MenuItem, getBloodBankMenu, getDonorMenu, getHospitalMenu, getItSupportMenu, getCampaignOrgMenu } from "@/config";

/**
 * Fixed from the original: `handleSignOut` there hardcoded
 * `post_logout_redirect_uri=http://localhost:3000`, which broke logout on
 * any non-local deployment. `useAuth().logout()` uses oidc-client-ts,
 * which derives the redirect from `oidcConfig.post_logout_redirect_uri`
 * (window.location.origin) — see auth/oidcConfig.ts.
 */
export const useNavItems = (dashboardType: DashboardType): MenuItem[] => {
  const location = useLocation();
  const { logout } = useAuth();
  const pathname = location.pathname;

  const handleSignOut = () => {
    void logout();
  };

  switch (dashboardType) {
    case "donor":
      return getDonorMenu(pathname, handleSignOut);
    case "hospital":
      return getHospitalMenu(pathname, handleSignOut);
    case "it_support":
      return getItSupportMenu(pathname, handleSignOut);
    case "campaign_org":
      return getCampaignOrgMenu(pathname, handleSignOut);
    case "blood_bank":
    default:
      return getBloodBankMenu(pathname, handleSignOut);
  }
};
